import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import expDataTemplate from "../../utils/expData.template.json";
import axios from "axios";
const GIST_ID = "52552698c6328f5d5fe22567e535dd06";

export default function Simulation() {
  const { id } = useParams();
  const [simLink, setSimLink] = useState(
    expDataTemplate.expts[Number(id) - 1]["simulation-link"]
  );
  const axiosConfig = {
    method: "get",
    url: `https://api.github.com/gists/${GIST_ID}`,
    headers: {},
  };

  useEffect(() => {
    axios(axiosConfig)
      .then((res) => {
        console.log(JSON.parse(res.data.files["db.json"].content));
        setSimLink(
          JSON.parse(res.data.files["db.json"].content).expts[Number(id) - 1][
            "simulation-link"
          ]
        );
      })
      .catch((err) => {
        console.error(err);
      });
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="text-red-500 text-center font-bold md:text-xl lg:text-3xl">
        Note: Some Simulations require large amount of resources and may take
        more than a minute to load
      </div>
      <iframe
        title="simulation"
        src={simLink}
        className="w-100 h-screen"
      ></iframe>
    </>
  );
}
